import PageMeta from "../components/common/PageMeta";
import PageContainer from "../components/common/PageContainer";
import PageHeader from "../components/common/PageHeader";
import PaymentsCacheCoverage from "../components/dashboard/PaymentsCacheCoverage";

export default function ShopifyPaymentsCachePage() {
  return (
    <div>
      <PageMeta
        title="Chargemont | Shopify Payments Cache"
        description="Shopify payments cache coverage and import status"
      />
      <PageContainer>
        <PageHeader title="Shopify Payments Cache" />
        <PaymentsCacheCoverage />
      </PageContainer>
    </div>
  );
}
